import Vue from "vue";
import { ActionTree, MutationTree } from "vuex";
import { RootState } from "@/store/types";

export interface State {
  images: any;
  countries: any
}

const defaultState: State = {
  images: {},
  countries: [{ title: 'Россия', value: 'RU' }]
};

const getters = {
  imageById: (state: State) => (id: string) => state.images[id],
  getCountries: (state: State) => state.countries
};

const mutations: MutationTree<State> = {
  addImage(state, data: any) {
    let { id, url } = data;
    Vue.set(state.images, id, url);
  },

  setCountries(state, data) {
    state.countries = [...data]
  }
};

const actions: ActionTree<State, RootState> = {
  async addImage({ commit }, data) {
    try {
      let { photoKey, shardId } = data;
      const req: any = await Vue.axios({
        url: "/media-links",
        method: "POST",
        data: {
          keys: [photoKey],
        },
      });
      let url = "";
      fetch(req.data[photoKey]).then((res) =>
        res
          .clone()
          .blob()
          .then((ib) => {
            commit("addImage", { id: shardId, url: URL.createObjectURL(ib) });
          })
      );
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
